var _path, _path2, _g, _path3, _path4, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalPnl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12425_25407)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4344 14.676C24.4344 14.439 24.4404 14.282 24.4334 14.126C24.4094 13.582 23.9854 13.161 23.4794 13.173C22.9784 13.185 22.5774 13.597 22.5594 14.129C22.5504 14.409 22.5464 14.691 22.5614 14.971C22.5714 15.154 22.5054 15.233 22.3354 15.308C21.2134 15.803 20.5254 17.04 20.7154 18.194C20.9554 19.67 21.9864 20.574 23.5214 20.658C23.9244 20.68 24.2114 20.875 24.3644 21.245C24.5124 21.605 24.4444 21.943 24.1844 22.228C23.9204 22.515 23.5864 22.59 23.2144 22.488C22.8144 22.38 22.5354 22.102 22.2604 21.814C21.8854 21.423 21.3204 21.392 20.9444 21.73C20.5484 22.084 20.5244 22.64 20.8904 23.068C21.1392 23.3481 21.4194 23.5987 21.7254 23.815C21.9874 24.008 22.4184 24.023 22.5314 24.321C22.6414 24.612 22.5504 24.978 22.5604 25.31C22.5764 25.853 23.0004 26.278 23.5064 26.27C24.0054 26.263 24.4104 25.852 24.4324 25.32C24.4424 25.082 24.4544 24.84 24.4294 24.604C24.4034 24.342 24.4894 24.21 24.7374 24.092C25.8194 23.575 26.4574 22.367 26.2764 21.248C26.0364 19.775 25.0084 18.872 23.4694 18.785C23.0664 18.762 22.7794 18.567 22.6274 18.196C22.5559 18.0381 22.5329 17.8626 22.5614 17.6917C22.5899 17.5207 22.6686 17.3621 22.7874 17.236C23.0514 16.934 23.3934 16.851 23.7794 16.954C24.0794 17.034 24.3094 17.226 24.5424 17.421C24.9584 17.771 25.5154 17.731 25.8584 17.345C26.1834 16.978 26.1584 16.415 25.7934 16.05C25.5484 15.806 25.2794 15.573 24.9554 15.465C24.5044 15.315 24.3084 15.064 24.4344 14.676ZM31.9964 20.533C31.8664 21 31.8274 21.485 31.6944 21.954C31.2322 23.5788 30.2973 25.0294 29.0084 26.1213C27.7195 27.2132 26.135 27.8971 24.4564 28.086C20.0024 28.592 15.9114 25.531 15.1804 21.146C14.3984 16.454 17.5904 12.063 22.2784 11.378C26.8154 10.714 31.0754 13.805 31.8844 18.338C31.9184 18.528 31.8814 18.736 31.9964 18.911V20.533Z",
    fill: "#03F5AE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12425_25407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 16,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55469 0H22.5627V31.948H7.55469V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12425_25407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3108 31.948C11.3108 23.901 11.3108 15.855 11.3178 7.808C11.3178 7.543 11.2448 7.483 10.9898 7.488C10.1778 7.505 9.36484 7.496 8.55184 7.494C8.08284 7.492 7.75884 7.273 7.61284 6.866C7.47484 6.482 7.58284 6.106 7.93284 5.806C10.0818 3.966 12.2328 2.126 14.3848 0.287002C14.8318 -0.093998 15.2878 -0.096998 15.7358 0.286002C17.3428 1.656 18.9458 3.031 20.5518 4.404C21.1048 4.877 21.6668 5.341 22.2108 5.826C22.7928 6.345 22.6248 7.213 21.9108 7.454C21.7868 7.496 21.6648 7.494 21.5408 7.494C20.7378 7.494 19.9358 7.504 19.1338 7.488C18.8818 7.483 18.7968 7.538 18.8028 7.806C18.8218 8.638 18.8028 9.47 18.8148 10.301C18.8178 10.506 18.7498 10.603 18.5708 10.706C15.5168 12.453 13.6978 15.061 13.2628 18.552C12.7458 22.691 14.8668 26.708 18.5628 28.733C18.7588 28.84 18.8198 28.955 18.8138 29.166C18.8008 29.685 18.7848 30.206 18.8158 30.724C18.8508 31.297 18.6618 31.714 18.1228 31.948H11.3108Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6875 31.948V14.297C5.6875 13.514 6.0255 13.173 6.8005 13.173C7.5605 13.173 8.3215 13.185 9.0805 13.167C9.3575 13.16 9.4435 13.223 9.4435 13.517C9.4335 19.494 9.4355 25.472 9.4355 31.449L9.4375 31.948H5.6875Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12425_25407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 4,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.649H3.758V31.948H0V20.649Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12425_25407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.344C0.231 20.827 0.626 20.626 1.193 20.651C1.909 20.683 2.628 20.674 3.345 20.651C3.657 20.641 3.759 20.708 3.758 21.047C3.744 24.68 3.75 28.314 3.75 31.948H0.687C0.38019 31.8135 0.135037 31.5687 0 31.262L0 21.344Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12425_25407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPnl);
export default __webpack_public_path__ + "static/media/total_pnl.c9f9cc89fcd0e3fb50d11c801694f051.svg";
export { ForwardRef as ReactComponent };